module.exports = __webpack_public_path__ + "static/media/stopperImg.cd5042f0.png";